import { combineReducers } from "redux";
import * as types from "../../../_constants/types";

const fetch = (state = { loading: false }, action) => {
    switch (action.type) {
        case types.RETURN_ORDER_CALCULATING:
            return { loading: true };

        case types.RETURN_ORDER_CALCULATING_COMPLETED:
            return { loading: false };

        case types.RETURN_ORDER_CALCULATING_FAILED:
            return { loading: false, err: action.err };

        default:
            return state;
    }
};

const data = (state = {}, action) => {
    switch (action.type) {
        case types.RETURN_ORDER_CALCULATE_LOAD:
            return JSON.parse(JSON.stringify(action.data));

        case types.RESET:
        case types.RETURN_ORDER_CALCULATE_RESET:
            return {};

        default:
            return state;
    }
};

export default combineReducers({ data, fetch });
